module.exports = __webpack_public_path__ + "img/pic_userNoExample.2aeb07fc.png";